export const parseStaffName = (name) => {
  if (!name) return { first_name: "", last_name: "" }
  const parts = name.split(" ")
  return {
    first_name: parts[0] || "",
    last_name: parts[1] || ""
  }
}

export const getStatusConfig = (status, t) => {
  const statusConfig = {
    Active: { color: "green", text: t("staff.status.active") },
    Deactivated: { color: "red", text: t("staff.status.deactivated") }
  }

  return statusConfig[status] || { color: "default", text: status }
}

export const getRoleConfig = (role) => {
  return { color: "var(--color-primary-surface)", text: role }
}

export const createMenuItems = (staffMember, handlers, t, userRole = null) => {
  const { onEdit, onDeactivate, onActivate, onDelete, onSendInstructions } = handlers
  const canEdit = staffMember?.can_edit || false
  const passwordSet = staffMember?.password_set || false
  const isActivateAction = staffMember.status !== "Active"

  const allMenuItems = [
    {
      key: "edit",
      label: t("staff.menu_items.edit"),
      onClick: () => onEdit(staffMember.id),
      show: canEdit
    },
    {
      key: "send_instructions",
      label: t("staff.menu_items.send_instructions"),
      onClick: () => onSendInstructions(staffMember),
      disabled: passwordSet,
      show: canEdit
    },
    {
      key: "deactivate",
      label: isActivateAction ? t("staff.menu_items.activate") : t("staff.menu_items.deactivate"),
      onClick: () => {
        if (staffMember.status === "Active") {
          onDeactivate(staffMember)
        } else {
          onActivate(staffMember)
        }
      },
      disabled: isActivateAction && !passwordSet,
      show: canEdit
    },
    {
      key: "delete",
      label: t("staff.menu_items.delete"),
      onClick: () => onDelete(staffMember),
      danger: true,
      show: canEdit
    }
  ]

  const filteredMenuItems = allMenuItems.filter((item) => item.show)

  return filteredMenuItems.map(({ show, ...item }) => item)
}
